import {
    initializeRealUserMonitoring,
    setUser,
} from '@eb/real-user-monitoring';

import { App, User } from '../types';

export const initRUM = (app: App, user: User) => {
    const service = app.name;
    const version = app.version;
    const sampleRate = 20;
    const id = user.publicId;
    const name = user.fullName;
    const email = user.email;

    initializeRealUserMonitoring({
        sampleRate,
        service,
        version,
    });

    setUser({
        id,
        name,
        email,
    });
};
